




































import { Component, Mixins } from 'vue-property-decorator'
import { Track } from '@/classes/track'
import { tracksToCsv } from '@/helpers/export/csv'
import { tracksToM3u8 } from '@/helpers/export/m3u'
import { tracksToHtml } from '@/helpers/export/html'
import { IColumnHeader } from '@/constants'
import { download } from '@/helpers/download'
import { USAGE_STAT_FEATURES } from '@/system/usage-stats'
import { HistoryViewMixin } from '@/mixins'

@Component({})
export default class Download extends Mixins(HistoryViewMixin) {
  get selectedTracks(): Track[] {
    return this.$store.getters['library/selectedTracks']
  }

  get columns(): IColumnHeader[] {
    return this.$store.state.exporttofile.columns
  }

  downloadSelectedTracksAsCsv() {
    const csvString: string = tracksToCsv(this.selectedTracks, this.columns)

    const d = new Date()

    download(csvString, `rekordcloud-export_${d.getFullYear()}-${d.getMonth() + 1}-${d.getDate()}.csv`)

    window.addUsageStat(USAGE_STAT_FEATURES.ExportToFile, 'csv', 'download')
  }

  downloadSelectedTracksAsM3u() {
    const m3u8String: string = tracksToM3u8(this.selectedTracks)

    const d = new Date()

    download(m3u8String, `playlist_${d.getFullYear()}-${d.getMonth() + 1}-${d.getDate()}.m3u8`)

    window.addUsageStat(USAGE_STAT_FEATURES.ExportToFile, 'm3u', 'download')
  }

  openPlaylistHtml() {
    const d = new Date()

    const html: string = tracksToHtml(this.selectedTracks, this.columns)

    // const newTab = window.open()
    // if (newTab) newTab.document.write(html)

    download(html, `playlist_${d.getFullYear()}-${d.getMonth() + 1}-${d.getDate()}.html`)

    window.addUsageStat(USAGE_STAT_FEATURES.ExportToFile, 'html', 'download')
  }

  async created() {
    if (this.selectedTracks.length === 0) {
      await this.$router.replace({
        name: 'export to file'
      })
    }
  }
}
